var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBanners
    ? _c("div", { staticClass: "category-banner-slot" }, [
        _c(
          "div",
          { staticClass: "category-banner-slot__inner" },
          _vm._l(_vm.BANNERS, function(banner) {
            return _c("category-banner", {
              key: banner.id,
              attrs: { data: banner, "slot-name": _vm.slotName }
            })
          }),
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }